<div class="relative" [ngClass]="Theme">
    <div [ngClass]="{'visibility_hidden': Loading_sk}">
        {{Text}}
    </div>
    <ng-container *ngIf="Loading_sk">
        <!-- <app-skeletoons loading [Theme]="'skeletoons-primary'" [Radius]="RadiusLoading"></app-skeletoons> -->
    </ng-container>

</div>